
import lazyload from "@/directives/lazyload";

import tube8 from "@/assets/images/main/example/xxx/tube8.png"
import hclips from "@/assets/images/main/example/xxx/hclips.png"
import nuvid from "@/assets/images/main/example/xxx/nuvid.png"
import pornhub from "@/assets/images/main/example/xxx/pornhub.png"
import redtube from "@/assets/images/main/example/xxx/redtube.png"
import tna from "@/assets/images/main/example/xxx/tna.png"
import upornia from "@/assets/images/main/example/xxx/upornia.png"
import xtube from "@/assets/images/main/example/xxx/xtube.png"
import youporn from "@/assets/images/main/example/xxx/youporn.png"
import porntube from "@/assets/images/main/example/cam/porntube.png"

export default {
  data() {
    return {
      images: {
        tube8,
        hclips,
        nuvid,
        pornhub,
        redtube,
        tna,
        upornia,
        xtube,
        youporn,
        porntube
      },
    };
  },
  directives: {
    lazyload,
  },
};
